import { supabase } from '../lib/supabaseClient';
import type { UserRole } from '../types/db';

export async function fetchUsers() {
  const { data, error } = await supabase.functions.invoke('fetch-users');

  if (error) {
    /* console removed */
    throw error;
  }

  return data ?? [];
}

export async function createUser(payload: {
  email: string;
  password: string;
  name: string;
  role: UserRole;
  branch_id: string;
}) {
  const { data, error } = await supabase.functions.invoke('create-admin-user', {
    body: {
      email: payload.email,
      password: payload.password,
      name: payload.name,
      role: payload.role,
      branch_id: payload.branch_id,
    },
  });

  if (error) throw error;
  return data;
}

export async function updateUser(payload: {
  user_id: string;
  name?: string;
  role?: UserRole;
  branch_id?: string | null;
}) {
  const { data, error } = await supabase.functions.invoke('update-user', {
    body: payload,
  });
  if (error) throw error;
  return data;
}

export async function deleteUser(id: string) {
  const { data, error } = await supabase.functions.invoke('delete-user', {
    body: { user_id: id },
  });
  if (error) throw error;
  return data;
}
